import initializeLazyScenarioStore from '../actions/initializeLazyScenarioStore';
import getStore, { createDefaultSearchStore } from '../store/store';
import { getScenarioIdKey } from 'owa-search-next-common';
import { mutator } from 'satcheljs';

mutator(initializeLazyScenarioStore, actionMessage => {
    const scenarioIdKey = getScenarioIdKey(actionMessage.scenarioId);

    /**
     * If instance store already exists, return as the store is already
     * initialized.
     */
    if (getStore().scenarioStores.get(scenarioIdKey)) {
        return;
    }

    // Initialize instance store with default values.
    getStore().scenarioStores.set(scenarioIdKey, { ...createDefaultSearchStore() });

    // Set isUsing3S value based on action message.
    const store = getStore().scenarioStores.get(scenarioIdKey);
    store.isUsing3S = actionMessage.isUsing3S;
});
